module.exports = {
  "name": "--pf-c-popover--MaxWidth",
  "value": "calc(2rem + 18.75rem)",
  "var": "var(--pf-c-popover--MaxWidth)"
};